export const scrollLock = (value: boolean) => {
  const body = document.querySelector("body");

  if (value) {
    body?.classList.add("menu--opened");
  } else {
    body?.classList.remove("menu--opened");
  }
};
